import styled from "styled-components";
import { Colors } from "../../../../values/colors";

export const Wrapper = styled.div`
  padding: 10px 20px;
  margin: 16px 24px 20px;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 10px;
  background: ${Colors.ultraLightGray3};
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 99px;
  border: 1px solid ${Colors.primary};
  background: ${Colors.primary}11;
`;

export const ChipRemove = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer !important;
  color: inherit;
`;
